import React from 'react';
import { useTranslation } from 'react-i18next';

export type EmptyResponseProps = {
  messageAborted: boolean;
  isDocumentMessage: boolean;
  messageIndex: number;
};

export const EmptyResponse = ({ messageAborted }: EmptyResponseProps) => {
  const { t } = useTranslation('intel');

  if (messageAborted) {
    return null;
  }

  return <p>{t('intel:empty')}</p>;
};
